import { useMutation } from "@apollo/react-hooks";
import { T } from '../../../utils/I18n/I18n';
import React from 'react';
import { useForm } from "react-hook-form";
import { CREATE_ADDRESS } from "../../../components/PersonalArea/PersonalAreaAddress/queriesAddress";
import FormInput from "../../../components/UI/FormInput/FormInput";
import "../../../components/UI/FormInput/FormInput.scss";
import { GET_CUSTOMER } from '../../../queries/customer';
import { countryCode } from '../../../utils/checkout';
import isVATValid from '../../../utils/isVATValid';
import PostcodeAndCity from './SelectCityByPostcode/PostcodeAndCity';

const NewAddressForm = ({
  setSavedAddress,
  setIsAdded,
  setSavedToAddressBook,
  setAddressId,
  setAddedNewAddress,
  isBusiness,
  setIsDirty,
}) => {
  const { register, handleSubmit, errors, setValue } = useForm();

  const [createAddress] = useMutation(CREATE_ADDRESS, {
    refetchQueries: [{ query: GET_CUSTOMER }],
    awaitRefetchQueries: true,
  });

  const submitHandler = async formData => {
    const { firstname, lastname, street, city, tel, postcode, save, country_code, company, vat_id } = formData;

    if (save) {
      const { data } = await createAddress({
        variables: { firstname, lastname, street, city, telephone: tel, postcode, country_code },
      });

      setSavedToAddressBook({
        added: true,
        identifier: data.createCustomerAddress.id,
      });

      setAddressId(data.createCustomerAddress.id);
    } else {
      setSavedAddress({
        company,
        vat_id,
        id: 'savedAddress',
        firstname,
        lastname,
        street,
        city,
        telephone: tel,
        postcode,
        country_code,
      });

      setAddressId('savedAddress');
    }

    setIsDirty(true);
    setIsAdded(true);
    setAddedNewAddress(true);
  };

  return (
    <div className="checkout-address-item__new-address">
      <form onSubmit={handleSubmit(submitHandler)}>
        {isBusiness && (
          <>
            <FormInput
              register={register}
              type="text"
              text={<T id="cartSummary.companyName" />}
              name="company"
              errors={errors}
            />

            <FormInput
              refProp={register({ required: true, validate: { oib: isVATValid } })}
              type="text"
              text={<T id="address.vatId" />}
              name="vat_id"
              errors={errors}
            />
          </>
        )}

        <FormInput
          register={register}
          type="text"
          text={<T id="registration.name" />}
          name="firstname"
          errors={errors}
        />

        <FormInput
          register={register}
          type="text"
          text={<T id="registration.lastName" />}
          name="lastname"
          errors={errors}
        />

        <FormInput
          register={register}
          type="text"
          minLength={3}
          text={<T id="address.street" />}
          name="street"
          errors={errors}
        />

        <PostcodeAndCity {...{ register, errors, setValue }} />

        <FormInput register={register} errors={errors} text={<T id="address.country" />} name="country_code">
          {countryCode === 'HR' && <option value="HR">Hrvatska</option>}
          {countryCode === 'RS' && <option value="RS">Srbija</option>}
          {countryCode === 'SI' && <option value="SI">Slovenija</option>}
        </FormInput>

        <FormInput
          register={register}
          type="number"
          text={<T id="cartSummary.cellphoneNumber" />}
          name="tel"
          errors={errors}
        />

        <div className="checkout-address-item__new-address__checkbox">
          <FormInput
            register={register}
            type="checkbox"
            name="save"
            errors={errors}
            register={register}
            isCheckbox
          />{' '}
          <p>
            <T id="address.saveAddress" />
          </p>
        </div>

        <div className="checkout-address-item__new-address__buttons">
          <button className="checkout__main__form__button exit" onClick={() => setIsAdded(false)} type="button">
            <T id="address.exit" />
          </button>

          <button className="checkout__main__form__button" type="submit">
            <T id="address.confirm" />
          </button>
        </div>
      </form>
    </div>
  );
};

export default NewAddressForm;